import { render, staticRenderFns } from "./GeneralInstitutionTimeTable.vue?vue&type=template&id=0e0fd8d3"
import script from "./GeneralInstitutionTimeTable.vue?vue&type=script&lang=js"
export * from "./GeneralInstitutionTimeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports